import { SidebarMenu } from '@ardoq/sidebar-menu';
import { Icon, IconName } from '@ardoq/icons';
import { TraversalBuilderViewState } from '../types';
import { FlexBox, Stack } from '@ardoq/layout';
import { colors } from '@ardoq/design-tokens';
import { Header3, Text } from '@ardoq/typography';
import { RequiredComponentsSelection } from './RequiredComponentsSelection';
import { RequiredComponentsCommands } from './requiredComponentsCommands';
import { ViewpointBuilderSidebarEmptyState } from '../ViewpointBuilderSidebarEmptyState';
import { t, type I18nLocale } from '@ardoq/i18n';

type RequiredComponentsTabSidebarProps = {
  state: TraversalBuilderViewState['requiredComponentsState'];
  commands: RequiredComponentsCommands;
  i18nLocale: I18nLocale;
};

const RequiredComponentsTabSidebar = ({
  state,
  commands,
  i18nLocale,
}: RequiredComponentsTabSidebarProps) => {
  return (
    <SidebarMenu
      isPageBodyMenu
      isResizable
      isRightContent
      headerBody={
        <FlexBox align="center" gap="xsmall" padding="medium">
          <Icon iconName={IconName.SETTINGS} color={colors.grey400} />
          <Header3>
            {t(
              i18nLocale,
              'viewpointBuilder:requiredComponents.header',
              'Select required paths'
            )}
          </Header3>
        </FlexBox>
      }
    >
      <FlexBox
        height="full"
        width="full"
        gap="medium"
        backgroundColor="surfaceDefault"
        justify="center"
      >
        <FlexBox padding="medium">
          <Stack gap="medium" align="center">
            <Text>
              {t(
                i18nLocale,
                'viewpointBuilder:requiredComponents.description',
                "Select the paths that the components in your dataset must match. Components that don't match your selected paths will be excluded from the dataset."
              )}
            </Text>
            {state && state.items.length ? (
              <RequiredComponentsSelection
                state={state}
                commands={commands}
                i18nLocale={i18nLocale}
              />
            ) : (
              <ViewpointBuilderSidebarEmptyState
                title={t(
                  i18nLocale,
                  'viewpointBuilder:requiredComponents.noItems.title',
                  'No paths selected yet'
                )}
                description={t(
                  i18nLocale,
                  'viewpointBuilder:requiredComponents.noItems.description',
                  'Select a component type in the dataset metamodel. All required paths start from the context component type.'
                )}
              />
            )}
          </Stack>
        </FlexBox>
      </FlexBox>
    </SidebarMenu>
  );
};

export { RequiredComponentsTabSidebar };
